import { render, staticRenderFns } from "./WorldViewList.vue?vue&type=template&id=f0a61666&scoped=true"
import script from "./WorldViewList.vue?vue&type=script&lang=ts"
export * from "./WorldViewList.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewList.vue?vue&type=style&index=0&id=f0a61666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a61666",
  null
  
)

export default component.exports